// Nivara Foundation - Translations: Deutsch / English / தமிழ்
export const TRANSLATIONS = {
  de: {
    // Brand
    "brand.tagline": "Swiss Collaborative Capital Platform — powered & designed by NIVARA Group",
    "brand.locations": "St. Gallen · Zürich · Bern · Genf",
    "brand.foundation": "Foundation",
    "brand.claim": "Zinsfrei. Gemeinschaftlich. Zukunftsorientiert.",

    // Nav
    "nav.login": "Anmelden",
    "nav.register": "Registrieren",
    "nav.dashboard": "Übersicht",
    "nav.groups": "Gruppen",
    "nav.users": "Benutzer",
    "nav.payments": "Zahlungen",
    "nav.auctions": "Bietverfahren",
    "nav.audit": "Audit-Log",
    "nav.exports": "Exports",
    "nav.notifications": "Benachrichtigungen",
    "nav.logout": "Abmelden",
    "nav.my_dashboard": "Mein Dashboard",
    "nav.my_group": "Meine Gruppe",

    // Roles
    "role.participant": "Teilnehmer",
    "role.admin": "Administrator",
    "role.controller": "Controlling",

    // Landing
    "landing.hero.headline_1": "Gemeinsam",
    "landing.hero.headline_2": "Zukunft finanzieren.",
    "landing.hero.subtitle": "Die Swiss Collaborative Capital Platform eröffnet neue Möglichkeiten für gemeinschaftliches und zinsfreies Sparen innerhalb ausgewählter Mitgliedergruppen. Bereits ab CHF 500.– bestehen verschiedene Teilnahmeoptionen. Die konkrete Beitragsstruktur und Gruppengrösse werden individuell im Rahmen der Anmeldung definiert.",
    "landing.hero.note": "Jede Anmeldung wird persönlich geprüft. Im direkten Austausch lernen wir unsere Mitglieder kennen und entscheiden gemeinsam über eine mögliche Aufnahme.",
    "landing.hero.cta_register": "Interesse anmelden",
    "landing.hero.cta_login": "Anmelden",
    "landing.stats.months": "Monate",
    "landing.stats.interest": "Zinsen",
    "landing.stats.transparent": "Transparent",
    "landing.how.label": "So funktioniert es",
    "landing.how.title": "Ein klarer Plan über 15 Monate.",
    "landing.how.subtitle": "Jede Gruppe besteht aus 15 (oder 12) Anteilen à CHF 2'000. Das Monatsvolumen beträgt CHF 30'000 und wird nach einem präzisen Plan ausgezahlt.",
    "landing.how.f1.title": "Gruppe mit 15 Anteilen",
    "landing.how.f1.text": "Je CHF 2'000 Basisbetrag pro Anteil — bis zu zwei Personen teilen sich einen Anteil.",
    "landing.how.f2.title": "Sinkender Zwangsabzug",
    "landing.how.f2.text": "Monat 2: CHF 5'200 → Monat 15: CHF 0. Die Auszahlung steigt jeden Monat.",
    "landing.how.f3.title": "Bietverfahren letzten Sonntag",
    "landing.how.f3.text": "Am letzten Sonntag des Monats um 10:00 Uhr bieten Teilnehmer in 100 CHF-Schritten.",
    "landing.how.f4.title": "Auszahlung bis zum 10.",
    "landing.how.f4.text": "Der Gewinner erhält die Auszahlung bis spätestens zum 10. des Monats.",
    "landing.trust.label": "Swiss Precision",
    "landing.trust.title": "Vertrauen durch Struktur.",
    "landing.trust.subtitle": "Jede Zahlung, jedes Gebot, jede Auszahlung wird geprüft und dokumentiert. Unsere Plattform bietet vollständige Transparenz für Teilnehmer, Admins und unabhängiges Controlling — bei strikter Anonymität zwischen Teilnehmern.",
    "landing.trust.p1.title": "Datenschutz zuerst",
    "landing.trust.p1.text": "Teilnehmer sehen niemals die Identität anderer Teilnehmer.",
    "landing.trust.p2.title": "Unabhängiges Controlling",
    "landing.trust.p2.text": "Prüfer überwachen Zahlungsflüsse und Gewinnerbestimmung.",
    "landing.trust.p3.title": "Vollständiges Audit-Log",
    "landing.trust.p3.text": "Jede Aktion wird nachvollziehbar protokolliert.",
    "landing.bid.label": "Das Bietverfahren",
    "landing.bid.title": "Anonym bieten. Fair gewinnen.",
    "landing.bid.subtitle": "Jeden letzten Sonntag des Monats um 10:00 Uhr findet das Bietverfahren statt. Teilnehmer, die noch nicht bezogen haben, geben ihr Gebot in 100 CHF-Schritten ab. Das höchste Gebot gewinnt. Falls niemand bietet, entscheidet das Losverfahren.",
    "landing.bid.steps": "Schritte",
    "landing.bid.date_label": "Termin",
    "landing.bid.date": "Letzter Sonntag",
    "landing.cta.title": "Werden Sie Teil der Nivara Community.",
    "landing.cta.subtitle": "Registrieren Sie sich und warten Sie auf die Zuteilung zu einer Gruppe durch unser Administrationsteam.",
    "landing.cta.register": "Jetzt registrieren",
    "landing.cta.login": "Bereits Mitglied? Anmelden",
    "landing.footer.copyright": "© 2026 Nivara Foundation",

    // Auth
    "auth.login.title": "Anmelden",
    "auth.login.subtitle": "Willkommen zurück bei der Nivara Foundation.",
    "auth.login.email": "E-Mail",
    "auth.login.password": "Passwort",
    "auth.login.submit": "Anmelden",
    "auth.login.submitting": "Anmelden…",
    "auth.login.no_account": "Noch kein Konto?",
    "auth.login.register_link": "Jetzt registrieren",
    "auth.login.welcome_back": "Willkommen zurück.",
    "auth.login.poetry_1": "Vertrauen.",
    "auth.login.poetry_2": "Transparenz.",
    "auth.login.poetry_text": "Melden Sie sich an, um Ihre Gruppe, Zahlungen und Bietverfahren zu verwalten.",

    "auth.register.title": "Registrieren",
    "auth.register.subtitle": "Erstellen Sie Ihr Teilnehmer-Konto.",
    "auth.register.name": "Vollständiger Name",
    "auth.register.phone": "Telefon (optional)",
    "auth.register.password_min": "Mindestens 6 Zeichen",
    "auth.register.submit": "Konto erstellen",
    "auth.register.submitting": "Konto wird erstellt…",
    "auth.register.have_account": "Bereits registriert?",
    "auth.register.login_link": "Anmelden",
    "auth.register.success": "Konto erstellt. Willkommen bei der Nivara Foundation.",
    "auth.register.poetry_1": "Gemeinschaft",
    "auth.register.poetry_2": "ohne Zinsen.",
    "auth.register.poetry_text": "Registrieren Sie sich. Ein Administrator wird Sie einer Gruppe zuteilen.",
    "auth.register.password_short": "Passwort muss mindestens 6 Zeichen lang sein.",

    // Dashboard
    "dashboard.welcome": "Willkommen",
    "dashboard.hello": "Hallo,",
    "dashboard.no_group_title": "Sie sind noch keiner Gruppe zugeteilt",
    "dashboard.no_group_text": "Ein Administrator wird Sie bald einer Gruppe zuweisen. Sie erhalten eine Benachrichtigung, sobald dies geschehen ist.",
    "dashboard.group": "Gruppe",
    "dashboard.share": "Anteil",
    "dashboard.current_month": "Aktueller Monat",
    "dashboard.monthly_amount": "Monatsbeitrag",
    "dashboard.month": "Monat",
    "dashboard.confirmed": "Monatsbeitrag bestätigt",
    "dashboard.pending": "Monatsbeitrag ausstehend",
    "dashboard.payment_due": "Einzahlung bis",
    "dashboard.payout_due": "Auszahlung bis",
    "dashboard.your_amount": "Ihr Betrag",
    "dashboard.active_auction": "Aktives Bietverfahren",
    "dashboard.active_auction_text": "Sie können jetzt ein Gebot abgeben.",
    "dashboard.go_to_auction": "Zum Bietverfahren",
    "dashboard.has_received_title": "Sie haben bereits bezogen",
    "dashboard.has_received_text": "Gewinn in Monat {month}. Sie zahlen weiterhin Monatsbeiträge bis zum Ende der Laufzeit.",
    "dashboard.group_title": "Gruppe ({count} Teilnehmer)",
    "dashboard.you": "Sie",
    "dashboard.received": "Bezogen",
    "dashboard.my_payments": "Meine Zahlungen",
    "dashboard.no_payments": "Noch keine Zahlungen erfasst.",
    "dashboard.payouts": "Auszahlungen",
    "dashboard.my_payouts_history": "Meine Auszahlungshistorie",
    "dashboard.no_payouts": "Noch keine Auszahlung.",

    "admin.title": "Administration",
    "admin.overview": "Übersicht",
    "admin.new_group": "Neue Gruppe",
    "admin.stats.groups": "Gruppen",
    "admin.stats.participants": "Teilnehmer gesamt",
    "admin.stats.received": "Eingegangen (CHF)",
    "admin.stats.open_auctions": "Offene Bietverfahren",
    "admin.all_groups": "Alle Gruppen",
    "admin.no_groups": "Noch keine Gruppen erstellt.",

    "controller.title": "Controlling",
    "controller.overview": "Prüfer-Übersicht",
    "controller.audit_count": "Audit-Einträge",
    "controller.payment_sum": "Summe bezahlt (CHF)",
    "controller.monitored_groups": "Überwachte Gruppen",
    "controller.recent_activity": "Letzte Aktivitäten",
    "controller.see_all": "Alle ansehen →",
    "controller.export_title": "Reports exportieren",
    "controller.export_payments": "Zahlungen (CSV)",
    "controller.export_audit": "Audit-Log (CSV)",

    // Common
    "common.loading": "Lade…",
    "common.cancel": "Abbrechen",
    "common.save": "Speichern",
    "common.back": "← Zurück",
    "common.start_date": "Start",
    "common.status": "Status",

    // Group detail
    "group.tab.overview": "Übersicht",
    "group.tab.participants": "Teilnehmer",
    "group.tab.contributions": "Monatsbeiträge",
    "group.tab.payments": "Zahlungen",
    "group.tab.auctions": "Bietverfahren",
    "group.add_participant": "Teilnehmer hinzufügen",
    "group.no_participants": "Keine Teilnehmer.",
    "group.bid_eligible": "Bieteberechtigt",
    "group.locked": "Gesperrt",
    "group.lock": "Sperren",
    "group.unlock": "Freigeben",
    "group.received_in": "Bezogen (M{month})",
    "group.col.month": "Monat",
    "group.col.volume": "Volumen",
    "group.col.deduction": "Abzug",
    "group.col.payout": "Auszahlung",
    "group.col.amount_per_share": "Monatsbeitrag",
    "group.col.due_date": "Frist",
    "group.col.status": "Status",
    "group.col.action": "Aktion",
    "group.confirmed": "Bestätigt",
    "group.open": "Offen",
    "group.confirm_notify": "Bestätigen & benachrichtigen",
    "group.create_payment": "Zahlung erfassen",
    "group.no_payments": "Keine Zahlungen.",
    "group.no_auctions": "Noch keine Bietverfahren.",
    "group.month_label": "Monat",
    "group.winning_bid": "Gewinngebot",
    "group.action_check": "Prüfen",
    "group.action_release": "Freigeben",
    "group.modal.add_participant": "Teilnehmer hinzufügen",
    "group.modal.user": "Benutzer E-Mail",
    "group.modal.share": "Anteil #",
    "group.modal.split": "Split mit (optional)",
    "group.modal.choose": "— wählen —",
    "group.modal.no_split": "— kein Split —",
    "group.modal.taken": "(vergeben)",
    "group.modal.add_btn": "Hinzufügen",
    "group.modal.payment_title": "Zahlung erfassen",
    "group.modal.amount": "Betrag (CHF)",
    "group.modal.method": "Zahlungsart",
    "group.modal.method.cash": "Bar",
    "group.modal.method.twint": "TWINT",
    "group.modal.method.bank": "Banküberweisung",
    "group.modal.record": "Erfassen",
    "group.confirm_remove": "Teilnehmer wirklich entfernen?",
    "group.toast.confirmed": "Monatsbeitrag bestätigt und Teilnehmer benachrichtigt.",
    "group.toast.removed": "Teilnehmer entfernt.",
    "group.toast.added": "Teilnehmer hinzugefügt.",
    "group.toast.payment_added": "Zahlung erfasst.",
    "group.toast.auction_open": "Bietverfahren Monat {month} geöffnet.",

    // Auction
    "auction.bidding": "Bietverfahren",
    "auction.month": "Monat",
    "auction.status": "Status",
    "auction.opened": "Geöffnet",
    "auction.highest_bid": "Höchstgebot",
    "auction.from": "von",
    "auction.place_bid_title": "Ihr Gebot abgeben",
    "auction.place_bid_subtitle": "Gebote müssen in 100 CHF-Schritten sein.",
    "auction.bid_btn": "Gebot CHF {amount} abgeben",
    "auction.close_btn": "Bietverfahren schließen",
    "auction.lottery_btn": "Losverfahren starten",
    "auction.confirm_close": "Bietverfahren schließen und Gewinner ermitteln?",
    "auction.confirm_lottery": "Losverfahren starten?",
    "auction.toast.bid_placed": "Gebot über CHF {amount} abgegeben.",
    "auction.toast.must_be_100": "Gebot muss in 100 CHF-Schritten sein.",
    "auction.toast.closed": "Bietverfahren abgeschlossen.",
    "auction.toast.lottery_done": "Losverfahren durchgeführt.",
    "auction.winner_title": "Gewinner ermittelt",
    "auction.winning_bid_label": "Gewinngebot:",
    "auction.by_lottery": "Losverfahren",
    "auction.bids_label": "Alle abgegebenen Gebote ({count})",
    "auction.no_bids": "Noch keine Gebote abgegeben.",
    "auction.list_title": "Bietverfahren",
    "auction.no_auctions": "Noch keine Bietverfahren.",

    // Payments
    "payments.title": "Alle Zahlungen",
    "payments.all_groups": "Alle Gruppen",
    "payments.col.date": "Datum",
    "payments.col.month": "Monat",
    "payments.col.amount": "Betrag",
    "payments.col.method": "Methode",
    "payments.col.status": "Status",
    "payments.col.action": "Aktion",
    "payments.no_data": "Keine Zahlungen.",

    // Audit
    "audit.title": "Audit-Log",
    "audit.col.time": "Zeit",
    "audit.col.user": "Benutzer",
    "audit.col.role": "Rolle",
    "audit.col.action": "Aktion",
    "audit.col.entity": "Objekt",
    "audit.no_data": "Keine Einträge.",

    // Notifications
    "notif.title": "Benachrichtigungen",
    "notif.label": "Push-Nachrichten",
    "notif.mark_all": "Alle als gelesen",
    "notif.mark_read": "Gelesen",
    "notif.empty": "Keine Benachrichtigungen.",

    // Admin extended
    "admin.users.title": "Benutzerverwaltung",
    "admin.users.col.name": "Name",
    "admin.users.col.email": "E-Mail",
    "admin.users.col.role": "Rolle",
    "admin.users.col.active": "Aktiv",
    "admin.users.col.action": "Aktion",
    "admin.users.edit": "Bearbeiten",
    "admin.users.modal.title": "Benutzer bearbeiten",
    "admin.users.modal.name": "Name",
    "admin.users.modal.phone": "Telefon",
    "admin.users.modal.role": "Rolle",
    "admin.users.modal.password": "Neues Passwort (optional)",
    "admin.users.modal.active": "Aktiv",
    "admin.users.modal.save": "Speichern",
    "admin.users.toast.updated": "Benutzer aktualisiert.",
    "admin.groups.title": "Gruppenverwaltung",
    "admin.groups.new_group": "Neue Gruppe",
    "admin.groups.no_groups": "Noch keine Gruppen.",
    "admin.groups.start": "Start",
    "admin.create.title": "Neue Gruppe erstellen",
    "admin.create.subtitle": "Definieren Sie Name, Anteile und Startdatum.",
    "admin.create.name": "Name der Gruppe",
    "admin.create.shares": "Anzahl Anteile",
    "admin.create.shares_n": "{n} Anteile",
    "admin.create.start_date": "Startdatum",
    "admin.create.start_july": "Juli 2026",
    "admin.create.start_august": "August 2026",
    "admin.create.base_amount": "Basisbetrag pro Anteil (CHF)",
    "admin.create.submit": "Gruppe erstellen",
    "admin.create.creating": "Erstelle…",
    "admin.create.toast.created": "Gruppe erstellt.",
    "admin.create.shares_custom": "Individuell",
    "admin.create.custom_shares": "Eigene Anzahl Anteile",
    "admin.create.bid_settings": "Bietverfahren",
    "admin.create.bid_weekday": "Tag (letztes Wochenende im Monat)",
    "admin.create.bid_saturday": "Samstag",
    "admin.create.bid_sunday": "Sonntag",
    "admin.create.bid_time": "Uhrzeit",
    "admin.create.deduction_plan": "Abzugsplan (anpassbar)",
    "admin.create.deduction_hint": "Passen Sie die monatlichen Abzüge bei Bedarf manuell an. Monat 1 geht vollständig an die Foundation.",
    "admin.create.reset_plan": "Plan zurücksetzen",
    "admin.users.delivery": "Übergabe Zugangsdaten",
    "delivery.email": "Per E-Mail",
    "delivery.phone": "Per Handy/SMS",
    "delivery.personal": "Persönlich",
    "admin.users.confirm_delete": "Diesen Benutzer wirklich löschen?",
    "admin.users.toast.deleted": "Benutzer gelöscht.",
    "admin.groups.confirm_delete": "Diese Gruppe und alle zugehörigen Daten (Teilnehmer, Zahlungen, Bietverfahren) wirklich löschen?",
    "group.bid_settings": "Bietverfahren-Einstellungen",
    "group.bid_settings_hint": "Findet am letzten Wochenende des Monats statt.",
    "group.col.bid_date": "Bietverfahren",
    "group.toast.settings_saved": "Einstellungen gespeichert.",
    "group.delete": "Gruppe löschen",
    "group.toast.deleted": "Gruppe gelöscht.",
    "group.save_settings": "Speichern",
    "group.modal.payer": "Wer hat bezahlt?",
    "group.modal.payer_choose": "Person wählen…",
    "group.paid_by": "Bezahlt von",
    "group.partial_paid": "Teilweise bezahlt",
    "group.fully_paid": "Vollständig bezahlt",

    // Interest form (Lead)
    "interest.title": "Exklusive Interessenbekundung",
    "interest.subtitle": "für die Swiss Collaborative Capital Platform",
    "interest.tagline": "Zinsfreie Gemeinschaftsfinanzierung neu definiert — diskret, gemeinschaftlich und werteorientiert.",
    "interest.intro_1": "Die Swiss Collaborative Capital Platform von NIVARA Group eröffnet ausgewählten Mitgliedern Zugang zu einer neuen Form gemeinschaftlicher und zinsfreier Vermögensbildung.",
    "interest.intro_2": "Im Mittelpunkt stehen Vertrauen, persönliche Prüfung und nachhaltige Zusammenarbeit innerhalb sorgfältig strukturierter Gruppen.",
    "interest.intro_3": "Bereits ab CHF 500.– bestehen verschiedene Beteiligungsmöglichkeiten. Die finale Gruppenzuteilung, Anzahl der möglichen Anteile sowie die jeweilige Gruppengrösse werden individuell im Rahmen des persönlichen Aufnahmeprozesses definiert.",
    "interest.intro_4": "Jede Interessenbekundung wird diskret geprüft. Im anschliessenden persönlichen Austausch lernen wir potenzielle Mitglieder kennen, beantworten offene Fragen und entscheiden gemeinsam über eine mögliche Aufnahme.",
    "interest.section.personal": "Persönliche Angaben",
    "interest.section.interest": "Interessenbereich",
    "interest.section.message": "Persönliche Nachricht",
    "interest.firstname": "Vorname",
    "interest.lastname": "Nachname",
    "interest.phone": "Telefonnummer",
    "interest.email": "E-Mail-Adresse (optional)",
    "interest.location": "Wohnort / Region (optional)",
    "interest.beteiligung": "Gewünschte Beteiligung",
    "interest.beteiligung.500": "CHF 500.–",
    "interest.beteiligung.1000": "CHF 1'000.–",
    "interest.beteiligung.2000": "CHF 2'000.–",
    "interest.beteiligung.individuell": "Individuelle Anfrage",
    "interest.anteile": "Anzahl gewünschter Anteile",
    "interest.anteile.1": "1 Anteil",
    "interest.anteile.2": "2 Anteile",
    "interest.anteile.individuell": "Individuelle Anfrage",
    "interest.message_label": "Ihre Motivation oder offene Fragen",
    "interest.message_placeholder": "Teilen Sie uns gerne Ihre Motivation oder offene Fragen mit.",
    "interest.contact_request": "Ich wünsche eine persönliche Kontaktaufnahme durch die NIVARA Group.",
    "interest.required_note": "Pflichtfelder: Vorname, Nachname, Telefonnummer, gewünschte Beteiligung und Nachricht.",
    "interest.submit": "Interessenbekundung übermitteln",
    "interest.submitting": "Wird übermittelt…",
    "interest.success.title": "Vielen Dank für Ihr Interesse.",
    "interest.success.body_1": "Ihre Anfrage wurde erfolgreich übermittelt und wird vertraulich geprüft.",
    "interest.success.body_2": "Ein Mitglied unseres Teams wird Sie persönlich kontaktieren, um weitere Informationen auszutauschen und die nächsten Schritte gemeinsam zu besprechen.",
    "interest.success.body_3": "Wir freuen uns darauf, Sie kennenzulernen.",
    "interest.error.required": "Bitte füllen Sie alle Pflichtfelder aus.",
    "interest.cta_anchor": "Interesse anmelden",
    "interest.return": "Zurück zur Startseite",

    // Login (Username)
    "auth.login.identifier": "Benutzername oder E-Mail",
    "auth.login.identifier_placeholder": "z. B. ihr.benutzername",
    "auth.login.no_account_text": "Sie sind noch nicht Mitglied?",
    "auth.login.interest_link": "Interessenbekundung einreichen",

    // Admin – Leads
    "nav.leads": "Interessenten",
    "admin.leads.title": "Interessenbekundungen",
    "admin.leads.subtitle": "Eingehende Interessenten prüfen und in Mitglieder konvertieren.",
    "admin.leads.empty": "Noch keine Interessenten eingereicht.",
    "admin.leads.col.date": "Datum",
    "admin.leads.col.name": "Name",
    "admin.leads.col.contact": "Kontakt",
    "admin.leads.col.beteiligung": "Beteiligung",
    "admin.leads.col.message": "Nachricht",
    "admin.leads.col.status": "Status",
    "admin.leads.col.action": "Aktion",
    "admin.leads.status.new": "Neu",
    "admin.leads.status.contacted": "Kontaktiert",
    "admin.leads.status.approved": "Geprüft",
    "admin.leads.status.rejected": "Abgelehnt",
    "admin.leads.status.converted": "Konvertiert",
    "admin.leads.create_user": "Konto anlegen",
    "admin.leads.delete": "Löschen",
    "admin.leads.confirm_delete": "Diese Interessenbekundung wirklich löschen?",
    "admin.leads.toast.status": "Status aktualisiert.",
    "admin.leads.toast.deleted": "Interessent gelöscht.",
    "admin.leads.created_user": "Konto wurde angelegt. Bitte teilen Sie Username + Passwort dem Mitglied diskret mit.",
    "admin.leads.modal.title": "Konto anlegen",
    "admin.leads.modal.subtitle": "Erstellen Sie ein Mitgliedskonto mit Username und Passwort.",
    "admin.leads.modal.username": "Benutzername",
    "admin.leads.modal.username_placeholder": "z. B. max.muster",
    "admin.leads.modal.password": "Initiales Passwort",
    "admin.leads.modal.name": "Vollständiger Name",
    "admin.leads.modal.phone": "Telefon",
    "admin.leads.modal.role": "Rolle",
    "admin.leads.modal.create": "Konto erstellen",

    // Admin – New user
    "admin.users.new": "Neuen Benutzer anlegen",
    "admin.users.new.title": "Neuen Benutzer anlegen",
    "admin.users.new.username": "Benutzername (für Login)",
    "admin.users.new.password": "Initiales Passwort",
    "admin.users.new.email": "E-Mail (optional)",
    "admin.users.col.username": "Benutzername",
  },

  en: {
    "brand.tagline": "Swiss Collaborative Capital Platform — powered & designed by NIVARA Group",
    "brand.locations": "St. Gallen · Zurich · Bern · Geneva",
    "brand.foundation": "Foundation",

    "nav.login": "Sign in",
    "nav.register": "Register",
    "nav.dashboard": "Overview",
    "nav.groups": "Groups",
    "nav.users": "Users",
    "nav.payments": "Payments",
    "nav.auctions": "Auctions",
    "nav.audit": "Audit Log",
    "nav.exports": "Exports",
    "nav.notifications": "Notifications",
    "nav.logout": "Sign out",
    "nav.my_dashboard": "My Dashboard",
    "nav.my_group": "My Group",

    "role.participant": "Participant",
    "role.admin": "Administrator",
    "role.controller": "Controller",

    "landing.hero.headline_1": "Shaping the future",
    "landing.hero.headline_2": "together.",
    "landing.hero.subtitle": "The Swiss Collaborative Capital Platform creates new opportunities for shared, interest-free saving within selected member circles. Participation options start from CHF 500. The specific contribution structure and group size are defined individually during the admission process.",
    "landing.hero.note": "Every application is personally reviewed. In direct dialogue we get to know our members and decide together on a possible admission.",
    "landing.hero.cta_register": "Express interest",
    "landing.hero.cta_login": "Sign in",
    "landing.stats.months": "months",
    "landing.stats.interest": "interest",
    "landing.stats.transparent": "transparent",
    "landing.how.label": "How it works",
    "landing.how.title": "A clear plan over 15 months.",
    "landing.how.subtitle": "Each group consists of 15 (or 12) shares of CHF 2,000. Monthly volume is CHF 30,000, distributed according to a precise plan.",
    "landing.how.f1.title": "Group of 15 shares",
    "landing.how.f1.text": "CHF 2,000 base amount per share — up to two members may share one stake.",
    "landing.how.f2.title": "Declining mandatory deduction",
    "landing.how.f2.text": "Month 2: CHF 5,200 → Month 15: CHF 0. The payout grows every month.",
    "landing.how.f3.title": "Auction last Sunday",
    "landing.how.f3.text": "On the last Sunday of the month at 10:00, members bid in CHF 100 increments.",
    "landing.how.f4.title": "Payout by the 10th",
    "landing.how.f4.text": "The winner receives their payout no later than the 10th of the month.",
    "landing.trust.label": "Swiss Precision",
    "landing.trust.title": "Trust through structure.",
    "landing.trust.subtitle": "Every payment, every bid, every payout is verified and recorded. Our platform offers full transparency for participants, admins and independent controllers — with strict anonymity between members.",
    "landing.trust.p1.title": "Privacy first",
    "landing.trust.p1.text": "Participants never see the identity of other members.",
    "landing.trust.p2.title": "Independent controlling",
    "landing.trust.p2.text": "Auditors monitor payment flows and winner determination.",
    "landing.trust.p3.title": "Complete audit log",
    "landing.trust.p3.text": "Every action is recorded for full traceability.",
    "landing.bid.label": "The auction",
    "landing.bid.title": "Bid anonymously. Win fairly.",
    "landing.bid.subtitle": "Every last Sunday of the month at 10:00, the auction takes place. Members who haven't received yet place bids in CHF 100 increments. The highest bid wins. If no one bids, a lottery decides.",
    "landing.bid.steps": "Increments",
    "landing.bid.date_label": "Date",
    "landing.bid.date": "Last Sunday",
    "landing.cta.title": "Become part of the Nivara community.",
    "landing.cta.subtitle": "Register and wait for assignment to a group by our administration team.",
    "landing.cta.register": "Register now",
    "landing.cta.login": "Already a member? Sign in",
    "landing.footer.copyright": "© 2026 Nivara Foundation",

    "auth.login.title": "Sign in",
    "auth.login.subtitle": "Welcome back to the Nivara Foundation.",
    "auth.login.email": "Email",
    "auth.login.password": "Password",
    "auth.login.submit": "Sign in",
    "auth.login.submitting": "Signing in…",
    "auth.login.no_account": "No account yet?",
    "auth.login.register_link": "Register now",
    "auth.login.welcome_back": "Welcome back.",
    "auth.login.poetry_1": "Trust.",
    "auth.login.poetry_2": "Transparency.",
    "auth.login.poetry_text": "Sign in to manage your group, payments and auctions.",

    "auth.register.title": "Register",
    "auth.register.subtitle": "Create your participant account.",
    "auth.register.name": "Full name",
    "auth.register.phone": "Phone (optional)",
    "auth.register.password_min": "At least 6 characters",
    "auth.register.submit": "Create account",
    "auth.register.submitting": "Creating account…",
    "auth.register.have_account": "Already registered?",
    "auth.register.login_link": "Sign in",
    "auth.register.success": "Account created. Welcome to the Nivara Foundation.",
    "auth.register.poetry_1": "Community",
    "auth.register.poetry_2": "without interest.",
    "auth.register.poetry_text": "Register. An administrator will assign you to a group.",
    "auth.register.password_short": "Password must be at least 6 characters.",

    "dashboard.welcome": "Welcome",
    "dashboard.hello": "Hello,",
    "dashboard.no_group_title": "You haven't been assigned to a group yet",
    "dashboard.no_group_text": "An administrator will assign you to a group soon. You'll receive a notification once that happens.",
    "dashboard.group": "Group",
    "dashboard.share": "Share",
    "dashboard.current_month": "Current month",
    "dashboard.monthly_amount": "Monthly contribution",
    "dashboard.month": "Month",
    "dashboard.confirmed": "Monthly amount confirmed",
    "dashboard.pending": "Monthly amount pending",
    "dashboard.payment_due": "Payment due",
    "dashboard.payout_due": "Payout due",
    "dashboard.your_amount": "Your amount",
    "dashboard.active_auction": "Active auction",
    "dashboard.active_auction_text": "You can place a bid now.",
    "dashboard.go_to_auction": "Go to auction",
    "dashboard.has_received_title": "You have already received",
    "dashboard.has_received_text": "Won in month {month}. You continue paying monthly until the end of the term.",
    "dashboard.group_title": "Group ({count} members)",
    "dashboard.you": "You",
    "dashboard.received": "Received",
    "dashboard.my_payments": "My payments",
    "dashboard.no_payments": "No payments recorded yet.",
    "dashboard.payouts": "Payouts",
    "dashboard.my_payouts_history": "My payout history",
    "dashboard.no_payouts": "No payouts yet.",

    "admin.title": "Administration",
    "admin.overview": "Overview",
    "admin.new_group": "New group",
    "admin.stats.groups": "Groups",
    "admin.stats.participants": "Total members",
    "admin.stats.received": "Received (CHF)",
    "admin.stats.open_auctions": "Open auctions",
    "admin.all_groups": "All groups",
    "admin.no_groups": "No groups created yet.",

    "controller.title": "Controlling",
    "controller.overview": "Auditor overview",
    "controller.audit_count": "Audit entries",
    "controller.payment_sum": "Total received (CHF)",
    "controller.monitored_groups": "Monitored groups",
    "controller.recent_activity": "Recent activity",
    "controller.see_all": "See all →",
    "controller.export_title": "Export reports",
    "controller.export_payments": "Payments (CSV)",
    "controller.export_audit": "Audit log (CSV)",

    "common.loading": "Loading…",
    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.back": "← Back",
    "common.start_date": "Start",
    "common.status": "Status",

    // Group detail
    "group.tab.overview": "Overview",
    "group.tab.participants": "Members",
    "group.tab.contributions": "Monthly amounts",
    "group.tab.payments": "Payments",
    "group.tab.auctions": "Auctions",
    "group.add_participant": "Add member",
    "group.no_participants": "No members.",
    "group.bid_eligible": "Eligible to bid",
    "group.locked": "Locked",
    "group.lock": "Lock",
    "group.unlock": "Unlock",
    "group.received_in": "Received (M{month})",
    "group.col.month": "Month",
    "group.col.volume": "Volume",
    "group.col.deduction": "Deduction",
    "group.col.payout": "Payout",
    "group.col.amount_per_share": "Monthly amount",
    "group.col.due_date": "Due",
    "group.col.status": "Status",
    "group.col.action": "Action",
    "group.confirmed": "Confirmed",
    "group.open": "Open",
    "group.confirm_notify": "Confirm & notify",
    "group.create_payment": "Record payment",
    "group.no_payments": "No payments.",
    "group.no_auctions": "No auctions yet.",
    "group.month_label": "Month",
    "group.winning_bid": "Winning bid",
    "group.action_check": "Check",
    "group.action_release": "Release",
    "group.modal.add_participant": "Add member",
    "group.modal.user": "User email",
    "group.modal.share": "Share #",
    "group.modal.split": "Split with (optional)",
    "group.modal.choose": "— choose —",
    "group.modal.no_split": "— no split —",
    "group.modal.taken": "(taken)",
    "group.modal.add_btn": "Add",
    "group.modal.payment_title": "Record payment",
    "group.modal.amount": "Amount (CHF)",
    "group.modal.method": "Payment method",
    "group.modal.method.cash": "Cash",
    "group.modal.method.twint": "TWINT",
    "group.modal.method.bank": "Bank transfer",
    "group.modal.record": "Record",
    "group.confirm_remove": "Remove member?",
    "group.toast.confirmed": "Monthly amount confirmed and members notified.",
    "group.toast.removed": "Member removed.",
    "group.toast.added": "Member added.",
    "group.toast.payment_added": "Payment recorded.",
    "group.toast.auction_open": "Auction for month {month} opened.",

    "auction.bidding": "Auction",
    "auction.month": "Month",
    "auction.status": "Status",
    "auction.opened": "Opened",
    "auction.highest_bid": "Highest bid",
    "auction.from": "by",
    "auction.place_bid_title": "Place your bid",
    "auction.place_bid_subtitle": "Bids must be in CHF 100 increments.",
    "auction.bid_btn": "Place bid CHF {amount}",
    "auction.close_btn": "Close auction",
    "auction.lottery_btn": "Run lottery",
    "auction.confirm_close": "Close auction and determine winner?",
    "auction.confirm_lottery": "Run lottery?",
    "auction.toast.bid_placed": "Bid of CHF {amount} placed.",
    "auction.toast.must_be_100": "Bid must be in CHF 100 increments.",
    "auction.toast.closed": "Auction closed.",
    "auction.toast.lottery_done": "Lottery completed.",
    "auction.winner_title": "Winner determined",
    "auction.winning_bid_label": "Winning bid:",
    "auction.by_lottery": "Lottery",
    "auction.bids_label": "All bids placed ({count})",
    "auction.no_bids": "No bids placed yet.",
    "auction.list_title": "Auctions",
    "auction.no_auctions": "No auctions yet.",

    "payments.title": "All payments",
    "payments.all_groups": "All groups",
    "payments.col.date": "Date",
    "payments.col.month": "Month",
    "payments.col.amount": "Amount",
    "payments.col.method": "Method",
    "payments.col.status": "Status",
    "payments.col.action": "Action",
    "payments.no_data": "No payments.",

    "audit.title": "Audit Log",
    "audit.col.time": "Time",
    "audit.col.user": "User",
    "audit.col.role": "Role",
    "audit.col.action": "Action",
    "audit.col.entity": "Entity",
    "audit.no_data": "No entries.",

    "notif.title": "Notifications",
    "notif.label": "Push notifications",
    "notif.mark_all": "Mark all read",
    "notif.mark_read": "Read",
    "notif.empty": "No notifications.",

    "admin.users.title": "User management",
    "admin.users.col.name": "Name",
    "admin.users.col.email": "Email",
    "admin.users.col.role": "Role",
    "admin.users.col.active": "Active",
    "admin.users.col.action": "Action",
    "admin.users.edit": "Edit",
    "admin.users.modal.title": "Edit user",
    "admin.users.modal.name": "Name",
    "admin.users.modal.phone": "Phone",
    "admin.users.modal.role": "Role",
    "admin.users.modal.password": "New password (optional)",
    "admin.users.modal.active": "Active",
    "admin.users.modal.save": "Save",
    "admin.users.toast.updated": "User updated.",
    "admin.groups.title": "Group management",
    "admin.groups.new_group": "New group",
    "admin.groups.no_groups": "No groups yet.",
    "admin.groups.start": "Start",
    "admin.create.title": "Create new group",
    "admin.create.subtitle": "Define name, shares and start date.",
    "admin.create.name": "Group name",
    "admin.create.shares": "Number of shares",
    "admin.create.shares_n": "{n} shares",
    "admin.create.start_date": "Start date",
    "admin.create.start_july": "July 2026",
    "admin.create.start_august": "August 2026",
    "admin.create.base_amount": "Base amount per share (CHF)",
    "admin.create.submit": "Create group",
    "admin.create.creating": "Creating…",
    "admin.create.toast.created": "Group created.",
    "admin.create.shares_custom": "Custom",
    "admin.create.custom_shares": "Custom number of shares",
    "admin.create.bid_settings": "Bidding process",
    "admin.create.bid_weekday": "Day (last weekend of month)",
    "admin.create.bid_saturday": "Saturday",
    "admin.create.bid_sunday": "Sunday",
    "admin.create.bid_time": "Time",
    "admin.create.deduction_plan": "Deduction plan (adjustable)",
    "admin.create.deduction_hint": "Adjust the monthly deductions manually if needed. Month 1 goes fully to the Foundation.",
    "admin.create.reset_plan": "Reset plan",
    "admin.users.delivery": "Credential delivery",
    "delivery.email": "By email",
    "delivery.phone": "By mobile/SMS",
    "delivery.personal": "In person",
    "admin.users.confirm_delete": "Really delete this user?",
    "admin.users.toast.deleted": "User deleted.",
    "admin.groups.confirm_delete": "Really delete this group and all related data (participants, payments, auctions)?",
    "group.bid_settings": "Bidding settings",
    "group.bid_settings_hint": "Takes place on the last weekend of the month.",
    "group.col.bid_date": "Bidding",
    "group.toast.settings_saved": "Settings saved.",
    "group.delete": "Delete group",
    "group.toast.deleted": "Group deleted.",
    "group.save_settings": "Save",
    "group.modal.payer": "Who paid?",
    "group.modal.payer_choose": "Choose person…",
    "group.paid_by": "Paid by",
    "group.partial_paid": "Partially paid",
    "group.fully_paid": "Fully paid",

    // Interest form (Lead)
    "interest.title": "Confidential Expression of Interest",
    "interest.subtitle": "for the Swiss Collaborative Capital Platform",
    "interest.tagline": "Interest-free community financing reimagined — discreet, communal and value-oriented.",
    "interest.intro_1": "The Swiss Collaborative Capital Platform by NIVARA Group offers selected members access to a new form of communal, interest-free wealth building.",
    "interest.intro_2": "It is built on trust, personal vetting and sustainable cooperation within carefully structured groups.",
    "interest.intro_3": "Participation starts at CHF 500.– with several options. The final group allocation, number of shares and group size are defined individually as part of the personal admission process.",
    "interest.intro_4": "Every expression of interest is reviewed in confidence. In a personal conversation we get to know prospective members, answer open questions and decide jointly on possible admission.",
    "interest.section.personal": "Personal details",
    "interest.section.interest": "Area of interest",
    "interest.section.message": "Personal message",
    "interest.firstname": "First name",
    "interest.lastname": "Last name",
    "interest.phone": "Phone number",
    "interest.email": "Email (optional)",
    "interest.location": "Place of residence / region (optional)",
    "interest.beteiligung": "Desired contribution",
    "interest.beteiligung.500": "CHF 500.–",
    "interest.beteiligung.1000": "CHF 1,000.–",
    "interest.beteiligung.2000": "CHF 2,000.–",
    "interest.beteiligung.individuell": "Individual request",
    "interest.anteile": "Number of shares desired",
    "interest.anteile.1": "1 share",
    "interest.anteile.2": "2 shares",
    "interest.anteile.individuell": "Individual request",
    "interest.message_label": "Your motivation or open questions",
    "interest.message_placeholder": "Share with us your motivation or open questions.",
    "interest.contact_request": "I would like to be contacted personally by NIVARA Group.",
    "interest.required_note": "Required: first name, last name, phone, desired contribution and message.",
    "interest.submit": "Submit expression of interest",
    "interest.submitting": "Submitting…",
    "interest.success.title": "Thank you for your interest.",
    "interest.success.body_1": "Your request has been submitted successfully and will be reviewed in confidence.",
    "interest.success.body_2": "A member of our team will contact you personally to share further information and discuss the next steps together.",
    "interest.success.body_3": "We look forward to meeting you.",
    "interest.error.required": "Please fill in all required fields.",
    "interest.cta_anchor": "Express interest",
    "interest.return": "Back to home",

    "auth.login.identifier": "Username or email",
    "auth.login.identifier_placeholder": "e.g. your.username",
    "auth.login.no_account_text": "Not yet a member?",
    "auth.login.interest_link": "Submit an expression of interest",

    "nav.leads": "Leads",
    "admin.leads.title": "Expressions of interest",
    "admin.leads.subtitle": "Review incoming leads and convert them into members.",
    "admin.leads.empty": "No leads submitted yet.",
    "admin.leads.col.date": "Date",
    "admin.leads.col.name": "Name",
    "admin.leads.col.contact": "Contact",
    "admin.leads.col.beteiligung": "Contribution",
    "admin.leads.col.message": "Message",
    "admin.leads.col.status": "Status",
    "admin.leads.col.action": "Action",
    "admin.leads.status.new": "New",
    "admin.leads.status.contacted": "Contacted",
    "admin.leads.status.approved": "Reviewed",
    "admin.leads.status.rejected": "Rejected",
    "admin.leads.status.converted": "Converted",
    "admin.leads.create_user": "Create account",
    "admin.leads.delete": "Delete",
    "admin.leads.confirm_delete": "Really delete this lead?",
    "admin.leads.toast.status": "Status updated.",
    "admin.leads.toast.deleted": "Lead deleted.",
    "admin.leads.created_user": "Account created. Please share username + password with the member discreetly.",
    "admin.leads.modal.title": "Create account",
    "admin.leads.modal.subtitle": "Create a member account with username and password.",
    "admin.leads.modal.username": "Username",
    "admin.leads.modal.username_placeholder": "e.g. max.muster",
    "admin.leads.modal.password": "Initial password",
    "admin.leads.modal.name": "Full name",
    "admin.leads.modal.phone": "Phone",
    "admin.leads.modal.role": "Role",
    "admin.leads.modal.create": "Create account",

    "admin.users.new": "Add new user",
    "admin.users.new.title": "Add new user",
    "admin.users.new.username": "Username (for login)",
    "admin.users.new.password": "Initial password",
    "admin.users.new.email": "Email (optional)",
    "admin.users.col.username": "Username",
  },

  ta: {
    "brand.tagline": "Swiss Collaborative Capital Platform — NIVARA குழுமத்தால் உருவாக்கப்பட்டது",
    "brand.locations": "சென் காலன் · ஸூரிக் · பெர்ன் · ஜெனிவா",
    "brand.foundation": "அறக்கட்டளை",

    "nav.login": "உள்நுழைய",
    "nav.register": "பதிவு செய்க",
    "nav.dashboard": "கண்ணோட்டம்",
    "nav.groups": "குழுக்கள்",
    "nav.users": "பயனர்கள்",
    "nav.payments": "கொடுப்பனவுகள்",
    "nav.auctions": "ஏல நடைமுறை",
    "nav.audit": "தணிக்கை பதிவு",
    "nav.exports": "ஏற்றுமதி",
    "nav.notifications": "அறிவிப்புகள்",
    "nav.logout": "வெளியேறு",
    "nav.my_dashboard": "எனது டாஷ்போர்டு",
    "nav.my_group": "எனது குழு",

    "role.participant": "பங்கேற்பாளர்",
    "role.admin": "நிர்வாகி",
    "role.controller": "கட்டுப்பாட்டு அதிகாரி",

    "landing.hero.headline_1": "எதிர்காலத்தை",
    "landing.hero.headline_2": "ஒன்றாக உருவாக்குவோம்.",
    "landing.hero.subtitle": "Swiss Collaborative Capital Platform தேர்ந்தெடுக்கப்பட்ட உறுப்பினர் குழுக்களுக்குள் கூட்டு மற்றும் வட்டியில்லா சேமிப்பிற்கான புதிய வாய்ப்புகளை உருவாக்குகிறது. CHF 500 முதல் பல்வேறு பங்கேற்பு விருப்பங்கள் உள்ளன. துல்லியமான பங்களிப்பு கட்டமைப்பு மற்றும் குழு அளவு சேர்க்கை நடைமுறையின் போது தனித்தனியாக தீர்மானிக்கப்படுகிறது.",
    "landing.hero.note": "ஒவ்வொரு விண்ணப்பமும் நேரடியாக ஆய்வு செய்யப்படுகிறது. நேரடி உரையாடலில் எங்கள் உறுப்பினர்களை அறிந்து, சாத்தியமான சேர்க்கை குறித்து ஒன்றாக முடிவு செய்கிறோம்.",
    "landing.hero.cta_register": "ஆர்வத்தை பதிவு செய்",
    "landing.hero.cta_login": "உள்நுழைய",
    "landing.stats.months": "மாதங்கள்",
    "landing.stats.interest": "வட்டி",
    "landing.stats.transparent": "வெளிப்படை",
    "landing.how.label": "எவ்வாறு செயல்படுகிறது",
    "landing.how.title": "15 மாதங்களில் தெளிவான திட்டம்.",
    "landing.how.subtitle": "ஒவ்வொரு குழுவும் CHF 2,000 மதிப்புள்ள 15 (அல்லது 12) பங்குகளைக் கொண்டுள்ளது. மாத மொத்த மதிப்பு CHF 30,000, துல்லியமான திட்டத்தின்படி வழங்கப்படுகிறது.",
    "landing.how.f1.title": "15 பங்குகள் கொண்ட குழு",
    "landing.how.f1.text": "ஒவ்வொரு பங்கிற்கும் CHF 2,000 அடிப்படை தொகை — இரு உறுப்பினர்கள் ஒரு பங்கை பகிர்ந்து கொள்ளலாம்.",
    "landing.how.f2.title": "குறையும் கட்டாய கழிவு",
    "landing.how.f2.text": "மாதம் 2: CHF 5,200 → மாதம் 15: CHF 0. ஒவ்வொரு மாதமும் வழங்கல் தொகை அதிகரிக்கிறது.",
    "landing.how.f3.title": "கடைசி ஞாயிற்றுக்கிழமை ஏலம்",
    "landing.how.f3.text": "ஒவ்வொரு மாதத்தின் கடைசி ஞாயிற்றுக்கிழமை 10:00 மணிக்கு, உறுப்பினர்கள் CHF 100 படி உயர்வுகளில் ஏலம் இடுகிறார்கள்.",
    "landing.how.f4.title": "10-ம் தேதிக்குள் வழங்கல்",
    "landing.how.f4.text": "வெற்றியாளர் மாதத்தின் 10-ம் தேதிக்கு முன் தனது தொகையைப் பெறுவார்.",
    "landing.trust.label": "சுவிஸ் துல்லியம்",
    "landing.trust.title": "கட்டமைப்பின் மூலம் நம்பிக்கை.",
    "landing.trust.subtitle": "ஒவ்வொரு கொடுப்பனவும், ஒவ்வொரு ஏலமும், ஒவ்வொரு வழங்கலும் சரிபார்க்கப்பட்டு பதிவு செய்யப்படுகிறது. எங்கள் தளம் பங்கேற்பாளர்கள், நிர்வாகிகள் மற்றும் சுயாதீன கட்டுப்பாட்டாளர்களுக்கு முழு வெளிப்படைத்தன்மையை வழங்குகிறது — உறுப்பினர்களிடையே கடுமையான அநாமதேயத்துடன்.",
    "landing.trust.p1.title": "தனியுரிமை முதலில்",
    "landing.trust.p1.text": "பங்கேற்பாளர்கள் பிற உறுப்பினர்களின் அடையாளத்தை ஒருபோதும் காண மாட்டார்கள்.",
    "landing.trust.p2.title": "சுயாதீன கட்டுப்பாடு",
    "landing.trust.p2.text": "தணிக்கையாளர்கள் கொடுப்பனவு ஓட்டத்தையும் வெற்றியாளர் தீர்மானத்தையும் கண்காணிக்கின்றனர்.",
    "landing.trust.p3.title": "முழுமையான தணிக்கை பதிவு",
    "landing.trust.p3.text": "ஒவ்வொரு செயலும் முழு கண்காணிப்புக்காக பதிவு செய்யப்படுகிறது.",
    "landing.bid.label": "ஏல நடைமுறை",
    "landing.bid.title": "அநாமதேயமாக ஏலம் இடுங்கள். நியாயமாக வெல்லுங்கள்.",
    "landing.bid.subtitle": "ஒவ்வொரு மாதத்தின் கடைசி ஞாயிற்றுக்கிழமை 10:00 மணிக்கு ஏலம் நடைபெறுகிறது. இன்னும் பெறாத உறுப்பினர்கள் CHF 100 படி உயர்வுகளில் ஏலம் இடுகின்றனர். அதிக ஏலம் வெல்கிறது. யாரும் ஏலம் இடாவிட்டால், குலுக்கல் முறை முடிவு செய்யும்.",
    "landing.bid.steps": "படிகள்",
    "landing.bid.date_label": "தேதி",
    "landing.bid.date": "கடைசி ஞாயிறு",
    "landing.cta.title": "Nivara சமூகத்தின் ஒரு பகுதியாக மாறுங்கள்.",
    "landing.cta.subtitle": "பதிவு செய்யுங்கள். எங்கள் நிர்வாகக் குழு உங்களை ஒரு குழுவிற்கு ஒதுக்கும் வரை காத்திருங்கள்.",
    "landing.cta.register": "இப்போதே பதிவு செய்யுங்கள்",
    "landing.cta.login": "ஏற்கனவே உறுப்பினரா? உள்நுழையுங்கள்",
    "landing.footer.copyright": "© 2026 Nivara அறக்கட்டளை",

    "auth.login.title": "உள்நுழைய",
    "auth.login.subtitle": "Nivara அறக்கட்டளைக்கு மீண்டும் வருக.",
    "auth.login.email": "மின்னஞ்சல்",
    "auth.login.password": "கடவுச்சொல்",
    "auth.login.submit": "உள்நுழைய",
    "auth.login.submitting": "உள்நுழைகிறது…",
    "auth.login.no_account": "கணக்கு இல்லையா?",
    "auth.login.register_link": "இப்போதே பதிவு செய்யுங்கள்",
    "auth.login.welcome_back": "மீண்டும் வரவேற்கிறோம்.",
    "auth.login.poetry_1": "நம்பிக்கை.",
    "auth.login.poetry_2": "வெளிப்படை.",
    "auth.login.poetry_text": "உங்கள் குழு, கொடுப்பனவுகள் மற்றும் ஏல நடைமுறைகளை நிர்வகிக்க உள்நுழையுங்கள்.",

    "auth.register.title": "பதிவு செய்க",
    "auth.register.subtitle": "உங்கள் பங்கேற்பாளர் கணக்கை உருவாக்கவும்.",
    "auth.register.name": "முழுப் பெயர்",
    "auth.register.phone": "தொலைபேசி (விருப்பத்தேர்வு)",
    "auth.register.password_min": "குறைந்தது 6 எழுத்துகள்",
    "auth.register.submit": "கணக்கை உருவாக்கு",
    "auth.register.submitting": "கணக்கு உருவாக்கப்படுகிறது…",
    "auth.register.have_account": "ஏற்கனவே பதிவு செய்துள்ளீர்களா?",
    "auth.register.login_link": "உள்நுழைய",
    "auth.register.success": "கணக்கு உருவாக்கப்பட்டது. Nivara அறக்கட்டளைக்கு வருக.",
    "auth.register.poetry_1": "சமூகம்",
    "auth.register.poetry_2": "வட்டி இல்லாமல்.",
    "auth.register.poetry_text": "பதிவு செய்யுங்கள். ஒரு நிர்வாகி உங்களை ஒரு குழுவிற்கு ஒதுக்குவார்.",
    "auth.register.password_short": "கடவுச்சொல் குறைந்தது 6 எழுத்துகளைக் கொண்டிருக்க வேண்டும்.",

    "dashboard.welcome": "வரவேற்கிறோம்",
    "dashboard.hello": "வணக்கம்,",
    "dashboard.no_group_title": "நீங்கள் இன்னும் ஒரு குழுவிற்கு ஒதுக்கப்படவில்லை",
    "dashboard.no_group_text": "ஒரு நிர்வாகி விரைவில் உங்களை ஒரு குழுவிற்கு ஒதுக்குவார். அது நடந்தவுடன் நீங்கள் அறிவிப்பைப் பெறுவீர்கள்.",
    "dashboard.group": "குழு",
    "dashboard.share": "பங்கு",
    "dashboard.current_month": "தற்போதைய மாதம்",
    "dashboard.monthly_amount": "மாதாந்திர பங்களிப்பு",
    "dashboard.month": "மாதம்",
    "dashboard.confirmed": "மாத தொகை உறுதி செய்யப்பட்டது",
    "dashboard.pending": "மாத தொகை நிலுவையில் உள்ளது",
    "dashboard.payment_due": "கொடுப்பனவு கடைசி தேதி",
    "dashboard.payout_due": "வழங்கல் கடைசி தேதி",
    "dashboard.your_amount": "உங்கள் தொகை",
    "dashboard.active_auction": "செயலில் உள்ள ஏலம்",
    "dashboard.active_auction_text": "நீங்கள் இப்போது ஏலம் இடலாம்.",
    "dashboard.go_to_auction": "ஏலத்திற்கு செல்க",
    "dashboard.has_received_title": "நீங்கள் ஏற்கனவே பெற்றுள்ளீர்கள்",
    "dashboard.has_received_text": "மாதம் {month} இல் வென்றுள்ளீர்கள். நீங்கள் காலம் முடியும் வரை மாத பங்களிப்புகளை தொடர்ந்து செலுத்துகிறீர்கள்.",
    "dashboard.group_title": "குழு ({count} உறுப்பினர்கள்)",
    "dashboard.you": "நீங்கள்",
    "dashboard.received": "பெற்றது",
    "dashboard.my_payments": "எனது கொடுப்பனவுகள்",
    "dashboard.no_payments": "இன்னும் கொடுப்பனவுகள் பதிவு செய்யப்படவில்லை.",
    "dashboard.payouts": "வழங்கல்கள்",
    "dashboard.my_payouts_history": "எனது வழங்கல் வரலாறு",
    "dashboard.no_payouts": "இன்னும் வழங்கல்கள் இல்லை.",

    "admin.title": "நிர்வாகம்",
    "admin.overview": "கண்ணோட்டம்",
    "admin.new_group": "புதிய குழு",
    "admin.stats.groups": "குழுக்கள்",
    "admin.stats.participants": "மொத்த உறுப்பினர்கள்",
    "admin.stats.received": "பெறப்பட்டது (CHF)",
    "admin.stats.open_auctions": "திறந்த ஏலங்கள்",
    "admin.all_groups": "அனைத்து குழுக்கள்",
    "admin.no_groups": "இன்னும் குழுக்கள் உருவாக்கப்படவில்லை.",

    "controller.title": "கட்டுப்பாடு",
    "controller.overview": "தணிக்கையாளர் கண்ணோட்டம்",
    "controller.audit_count": "தணிக்கை பதிவுகள்",
    "controller.payment_sum": "மொத்த பெறப்பட்டது (CHF)",
    "controller.monitored_groups": "கண்காணிக்கப்படும் குழுக்கள்",
    "controller.recent_activity": "சமீபத்திய செயல்பாடு",
    "controller.see_all": "அனைத்தையும் காண →",
    "controller.export_title": "அறிக்கைகளை ஏற்றுமதி செய்க",
    "controller.export_payments": "கொடுப்பனவுகள் (CSV)",
    "controller.export_audit": "தணிக்கை பதிவு (CSV)",

    "common.loading": "ஏற்றுகிறது…",
    "common.cancel": "ரத்து செய்",
    "common.save": "சேமி",
    "common.back": "← பின்னால்",
    "common.start_date": "தொடக்கம்",
    "common.status": "நிலை",

    "group.tab.overview": "கண்ணோட்டம்",
    "group.tab.participants": "உறுப்பினர்கள்",
    "group.tab.contributions": "மாத பங்களிப்புகள்",
    "group.tab.payments": "கொடுப்பனவுகள்",
    "group.tab.auctions": "ஏல நடைமுறை",
    "group.add_participant": "உறுப்பினரைச் சேர்",
    "group.no_participants": "உறுப்பினர்கள் இல்லை.",
    "group.bid_eligible": "ஏலம் இட தகுதி",
    "group.locked": "பூட்டப்பட்டது",
    "group.lock": "பூட்டு",
    "group.unlock": "திற",
    "group.received_in": "பெற்றது (M{month})",
    "group.col.month": "மாதம்",
    "group.col.volume": "மொத்தம்",
    "group.col.deduction": "கழிவு",
    "group.col.payout": "வழங்கல்",
    "group.col.amount_per_share": "மாத தொகை",
    "group.col.due_date": "கடைசி தேதி",
    "group.col.status": "நிலை",
    "group.col.action": "செயல்",
    "group.confirmed": "உறுதி செய்யப்பட்டது",
    "group.open": "திறந்துள்ளது",
    "group.confirm_notify": "உறுதிசெய்து அறிவி",
    "group.create_payment": "கொடுப்பனவு பதிவு",
    "group.no_payments": "கொடுப்பனவுகள் இல்லை.",
    "group.no_auctions": "இன்னும் ஏலங்கள் இல்லை.",
    "group.month_label": "மாதம்",
    "group.winning_bid": "வெற்றி ஏலம்",
    "group.action_check": "சரிபார்",
    "group.action_release": "வெளியிடு",
    "group.modal.add_participant": "உறுப்பினரைச் சேர்",
    "group.modal.user": "பயனர் மின்னஞ்சல்",
    "group.modal.share": "பங்கு #",
    "group.modal.split": "பகிர்வு (விருப்பம்)",
    "group.modal.choose": "— தேர்வு —",
    "group.modal.no_split": "— பகிர்வு இல்லை —",
    "group.modal.taken": "(எடுக்கப்பட்டது)",
    "group.modal.add_btn": "சேர்",
    "group.modal.payment_title": "கொடுப்பனவு பதிவு",
    "group.modal.amount": "தொகை (CHF)",
    "group.modal.method": "கொடுப்பனவு முறை",
    "group.modal.method.cash": "ரொக்கம்",
    "group.modal.method.twint": "TWINT",
    "group.modal.method.bank": "வங்கி பரிமாற்றம்",
    "group.modal.record": "பதிவு செய்",
    "group.confirm_remove": "உறுப்பினரை நீக்கவா?",
    "group.toast.confirmed": "மாத தொகை உறுதி செய்யப்பட்டு உறுப்பினர்களுக்கு அறிவிக்கப்பட்டது.",
    "group.toast.removed": "உறுப்பினர் நீக்கப்பட்டார்.",
    "group.toast.added": "உறுப்பினர் சேர்க்கப்பட்டார்.",
    "group.toast.payment_added": "கொடுப்பனவு பதிவு செய்யப்பட்டது.",
    "group.toast.auction_open": "மாதம் {month} ஏலம் திறக்கப்பட்டது.",

    "auction.bidding": "ஏல நடைமுறை",
    "auction.month": "மாதம்",
    "auction.status": "நிலை",
    "auction.opened": "திறக்கப்பட்டது",
    "auction.highest_bid": "அதிக ஏலம்",
    "auction.from": "வழங்கியவர்",
    "auction.place_bid_title": "உங்கள் ஏலத்தை வையுங்கள்",
    "auction.place_bid_subtitle": "ஏலங்கள் CHF 100 படி உயர்வுகளில் இருக்க வேண்டும்.",
    "auction.bid_btn": "CHF {amount} ஏலம் இடு",
    "auction.close_btn": "ஏலத்தை மூடு",
    "auction.lottery_btn": "குலுக்கல் தொடங்கு",
    "auction.confirm_close": "ஏலத்தை மூடி வெற்றியாளரை தீர்மானிக்கவா?",
    "auction.confirm_lottery": "குலுக்கல் தொடங்கவா?",
    "auction.toast.bid_placed": "CHF {amount} ஏலம் வைக்கப்பட்டது.",
    "auction.toast.must_be_100": "ஏலம் CHF 100 படிகளில் இருக்க வேண்டும்.",
    "auction.toast.closed": "ஏலம் மூடப்பட்டது.",
    "auction.toast.lottery_done": "குலுக்கல் முடிந்தது.",
    "auction.winner_title": "வெற்றியாளர் தீர்மானிக்கப்பட்டது",
    "auction.winning_bid_label": "வெற்றி ஏலம்:",
    "auction.by_lottery": "குலுக்கல்",
    "auction.bids_label": "வைக்கப்பட்ட ஏலங்கள் ({count})",
    "auction.no_bids": "இன்னும் ஏலங்கள் வைக்கப்படவில்லை.",
    "auction.list_title": "ஏலங்கள்",
    "auction.no_auctions": "இன்னும் ஏலங்கள் இல்லை.",

    "payments.title": "அனைத்து கொடுப்பனவுகள்",
    "payments.all_groups": "அனைத்து குழுக்கள்",
    "payments.col.date": "தேதி",
    "payments.col.month": "மாதம்",
    "payments.col.amount": "தொகை",
    "payments.col.method": "முறை",
    "payments.col.status": "நிலை",
    "payments.col.action": "செயல்",
    "payments.no_data": "கொடுப்பனவுகள் இல்லை.",

    "audit.title": "தணிக்கை பதிவு",
    "audit.col.time": "நேரம்",
    "audit.col.user": "பயனர்",
    "audit.col.role": "பாத்திரம்",
    "audit.col.action": "செயல்",
    "audit.col.entity": "பொருள்",
    "audit.no_data": "பதிவுகள் இல்லை.",

    "notif.title": "அறிவிப்புகள்",
    "notif.label": "புஷ் அறிவிப்புகள்",
    "notif.mark_all": "அனைத்தையும் படித்ததாக",
    "notif.mark_read": "படித்தது",
    "notif.empty": "அறிவிப்புகள் இல்லை.",

    "admin.users.title": "பயனர் மேலாண்மை",
    "admin.users.col.name": "பெயர்",
    "admin.users.col.email": "மின்னஞ்சல்",
    "admin.users.col.role": "பாத்திரம்",
    "admin.users.col.active": "செயலில்",
    "admin.users.col.action": "செயல்",
    "admin.users.edit": "திருத்து",
    "admin.users.modal.title": "பயனரைத் திருத்து",
    "admin.users.modal.name": "பெயர்",
    "admin.users.modal.phone": "தொலைபேசி",
    "admin.users.modal.role": "பாத்திரம்",
    "admin.users.modal.password": "புதிய கடவுச்சொல் (விருப்பம்)",
    "admin.users.modal.active": "செயலில்",
    "admin.users.modal.save": "சேமி",
    "admin.users.toast.updated": "பயனர் புதுப்பிக்கப்பட்டார்.",
    "admin.groups.title": "குழு மேலாண்மை",
    "admin.groups.new_group": "புதிய குழு",
    "admin.groups.no_groups": "இன்னும் குழுக்கள் இல்லை.",
    "admin.groups.start": "தொடக்கம்",
    "admin.create.title": "புதிய குழுவை உருவாக்கு",
    "admin.create.subtitle": "பெயர், பங்குகள் மற்றும் தொடக்க தேதியை அமை.",
    "admin.create.name": "குழுவின் பெயர்",
    "admin.create.shares": "பங்குகளின் எண்ணிக்கை",
    "admin.create.shares_n": "{n} பங்குகள்",
    "admin.create.start_date": "தொடக்க தேதி",
    "admin.create.start_july": "ஜூலை 2026",
    "admin.create.start_august": "ஆகஸ்ட் 2026",
    "admin.create.base_amount": "ஒரு பங்கின் அடிப்படை தொகை (CHF)",
    "admin.create.submit": "குழுவை உருவாக்கு",
    "admin.create.creating": "உருவாக்குகிறது…",
    "admin.create.toast.created": "குழு உருவாக்கப்பட்டது.",
    "admin.create.shares_custom": "தனிப்பயன்",
    "admin.create.custom_shares": "சொந்த பங்கு எண்ணிக்கை",
    "admin.create.bid_settings": "ஏல முறை",
    "admin.create.bid_weekday": "நாள் (மாத இறுதி வார இறுதி)",
    "admin.create.bid_saturday": "சனி",
    "admin.create.bid_sunday": "ஞாயிறு",
    "admin.create.bid_time": "நேரம்",
    "admin.create.deduction_plan": "கழிவு திட்டம் (மாற்றக்கூடியது)",
    "admin.create.deduction_hint": "தேவைப்பட்டால் மாதாந்திர கழிவுகளை மாற்றலாம். மாதம் 1 முழுவதும் Foundation-க்கு.",
    "admin.create.reset_plan": "மீட்டமை",
    "admin.users.delivery": "கடவுச்சொல் வழங்கல்",
    "delivery.email": "மின்னஞ்சல் மூலம்",
    "delivery.phone": "கைபேசி/SMS மூலம்",
    "delivery.personal": "நேரில்",
    "admin.users.confirm_delete": "இந்த பயனரை நீக்கவா?",
    "admin.users.toast.deleted": "பயனர் நீக்கப்பட்டார்.",
    "admin.groups.confirm_delete": "இந்த குழுவையும் அனைத்து தொடர்புடைய தரவையும் நீக்கவா?",
    "group.bid_settings": "ஏல அமைப்புகள்",
    "group.bid_settings_hint": "மாதத்தின் கடைசி வார இறுதியில் நடைபெறும்.",
    "group.col.bid_date": "ஏலம்",
    "group.toast.settings_saved": "அமைப்புகள் சேமிக்கப்பட்டன.",
    "group.delete": "குழுவை நீக்கு",
    "group.toast.deleted": "குழு நீக்கப்பட்டது.",
    "group.save_settings": "சேமி",
    "group.modal.payer": "யார் செலுத்தினார்?",
    "group.modal.payer_choose": "நபரைத் தேர்ந்தெடு…",
    "group.paid_by": "செலுத்தியவர்",
    "group.partial_paid": "பகுதி செலுத்தப்பட்டது",
    "group.fully_paid": "முழுமையாக செலுத்தப்பட்டது",

    // Interest form (Lead)
    "interest.title": "ரகசிய ஆர்வ வெளிப்பாடு",
    "interest.subtitle": "Swiss Collaborative Capital Platform-க்காக",
    "interest.tagline": "வட்டியில்லா குழும நிதியளிப்பு புதிய வடிவில் — மறைமுகம், கூட்டாக, மதிப்புள்ளவை.",
    "interest.intro_1": "NIVARA குழுமத்தின் Swiss Collaborative Capital Platform தேர்ந்தெடுக்கப்பட்ட உறுப்பினர்களுக்கு புதிய வகையான கூட்டு, வட்டியில்லா செல்வ உருவாக்கத்திற்கு வழி திறக்கிறது.",
    "interest.intro_2": "நம்பிக்கை, தனிப்பட்ட சரிபார்ப்பு மற்றும் கவனமாக கட்டமைக்கப்பட்ட குழுக்களில் நிலையான ஒத்துழைப்பே மையமாகும்.",
    "interest.intro_3": "CHF 500.– முதல் பல்வேறு பங்களிப்பு வாய்ப்புகள் உள்ளன. இறுதி குழு ஒதுக்கீடு, பங்குகளின் எண்ணிக்கை மற்றும் குழு அளவு தனிப்பட்ட சேர்ப்பு செயல்முறையின் ஒரு பகுதியாக தீர்மானிக்கப்படும்.",
    "interest.intro_4": "ஒவ்வொரு ஆர்வ வெளிப்பாடும் ரகசியமாக ஆய்வு செய்யப்படுகிறது. தனிப்பட்ட உரையாடலில் வாய்ப்புள்ள உறுப்பினர்களை அறிந்து, கேள்விகளுக்கு பதிலளித்து, சேர்ப்பு குறித்து கூட்டாக முடிவு செய்கிறோம்.",
    "interest.section.personal": "தனிப்பட்ட விவரங்கள்",
    "interest.section.interest": "ஆர்வத் துறை",
    "interest.section.message": "தனிப்பட்ட செய்தி",
    "interest.firstname": "முதல் பெயர்",
    "interest.lastname": "குடும்பப் பெயர்",
    "interest.phone": "தொலைபேசி எண்",
    "interest.email": "மின்னஞ்சல் (விருப்பத்திற்கேற்ப)",
    "interest.location": "வசிக்கும் இடம் / பிராந்தியம் (விருப்பத்திற்கேற்ப)",
    "interest.beteiligung": "விரும்பும் பங்களிப்பு",
    "interest.beteiligung.500": "CHF 500.–",
    "interest.beteiligung.1000": "CHF 1'000.–",
    "interest.beteiligung.2000": "CHF 2'000.–",
    "interest.beteiligung.individuell": "தனிப்பட்ட கோரிக்கை",
    "interest.anteile": "விரும்பும் பங்குகளின் எண்ணிக்கை",
    "interest.anteile.1": "1 பங்கு",
    "interest.anteile.2": "2 பங்குகள்",
    "interest.anteile.individuell": "தனிப்பட்ட கோரிக்கை",
    "interest.message_label": "உங்கள் ஊக்கம் அல்லது கேள்விகள்",
    "interest.message_placeholder": "உங்கள் ஊக்கம் அல்லது கேள்விகளை எங்களுடன் பகிர்க.",
    "interest.contact_request": "NIVARA குழுமம் என்னை தனிப்பட்ட முறையில் தொடர்பு கொள்ள வேண்டும்.",
    "interest.required_note": "கட்டாயம்: முதல் பெயர், குடும்பப் பெயர், தொலைபேசி, விரும்பும் பங்களிப்பு மற்றும் செய்தி.",
    "interest.submit": "ஆர்வ வெளிப்பாட்டை சமர்ப்பி",
    "interest.submitting": "சமர்ப்பிக்கிறது…",
    "interest.success.title": "உங்கள் ஆர்வத்திற்கு நன்றி.",
    "interest.success.body_1": "உங்கள் கோரிக்கை வெற்றிகரமாக சமர்ப்பிக்கப்பட்டது மற்றும் ரகசியமாக ஆய்வு செய்யப்படும்.",
    "interest.success.body_2": "எங்கள் குழு உறுப்பினர் ஒருவர் கூடுதல் தகவல்களை பகிரவும் அடுத்த படிகளை விவாதிக்கவும் தனிப்பட்ட முறையில் உங்களை தொடர்பு கொள்வார்.",
    "interest.success.body_3": "உங்களை சந்திக்க ஆவலாக இருக்கிறோம்.",
    "interest.error.required": "தயவு செய்து அனைத்து கட்டாய புலங்களையும் நிரப்பவும்.",
    "interest.cta_anchor": "ஆர்வம் தெரிவி",
    "interest.return": "முகப்பிற்கு திரும்பு",

    "auth.login.identifier": "பயனர்பெயர் அல்லது மின்னஞ்சல்",
    "auth.login.identifier_placeholder": "உதா. your.username",
    "auth.login.no_account_text": "இன்னும் உறுப்பினர் இல்லையா?",
    "auth.login.interest_link": "ஆர்வ வெளிப்பாடு சமர்ப்பி",

    "nav.leads": "ஆர்வலர்கள்",
    "admin.leads.title": "ஆர்வ வெளிப்பாடுகள்",
    "admin.leads.subtitle": "புதிய ஆர்வலர்களை ஆய்வு செய்து உறுப்பினர்களாக மாற்றவும்.",
    "admin.leads.empty": "இன்னும் ஆர்வலர்கள் இல்லை.",
    "admin.leads.col.date": "தேதி",
    "admin.leads.col.name": "பெயர்",
    "admin.leads.col.contact": "தொடர்பு",
    "admin.leads.col.beteiligung": "பங்களிப்பு",
    "admin.leads.col.message": "செய்தி",
    "admin.leads.col.status": "நிலை",
    "admin.leads.col.action": "செயல்",
    "admin.leads.status.new": "புதியது",
    "admin.leads.status.contacted": "தொடர்பு கொள்ளப்பட்டது",
    "admin.leads.status.approved": "ஆய்வு செய்யப்பட்டது",
    "admin.leads.status.rejected": "மறுக்கப்பட்டது",
    "admin.leads.status.converted": "மாற்றப்பட்டது",
    "admin.leads.create_user": "கணக்கை உருவாக்கு",
    "admin.leads.delete": "நீக்கு",
    "admin.leads.confirm_delete": "இந்த ஆர்வலரை நீக்க வேண்டுமா?",
    "admin.leads.toast.status": "நிலை புதுப்பிக்கப்பட்டது.",
    "admin.leads.toast.deleted": "ஆர்வலர் நீக்கப்பட்டார்.",
    "admin.leads.created_user": "கணக்கு உருவாக்கப்பட்டது. பயனர்பெயர் + கடவுச்சொல்லை உறுப்பினருக்கு ரகசியமாக தெரிவிக்கவும்.",
    "admin.leads.modal.title": "கணக்கை உருவாக்கு",
    "admin.leads.modal.subtitle": "பயனர்பெயர் மற்றும் கடவுச்சொல்லுடன் உறுப்பினர் கணக்கை உருவாக்கவும்.",
    "admin.leads.modal.username": "பயனர்பெயர்",
    "admin.leads.modal.username_placeholder": "உதா. max.muster",
    "admin.leads.modal.password": "ஆரம்ப கடவுச்சொல்",
    "admin.leads.modal.name": "முழு பெயர்",
    "admin.leads.modal.phone": "தொலைபேசி",
    "admin.leads.modal.role": "பங்கு",
    "admin.leads.modal.create": "கணக்கை உருவாக்கு",

    "admin.users.new": "புதிய பயனரை சேர்",
    "admin.users.new.title": "புதிய பயனரை சேர்",
    "admin.users.new.username": "பயனர்பெயர் (உள்நுழைவுக்காக)",
    "admin.users.new.password": "ஆரம்ப கடவுச்சொல்",
    "admin.users.new.email": "மின்னஞ்சல் (விருப்பத்திற்கேற்ப)",
    "admin.users.col.username": "பயனர்பெயர்",
  },
};
